import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "../Common/searchFilterLayout.css";
import "./notification.css";
import { Fragment } from "react";
import { Box, TextField, Grid, FormControl, Select, MenuItem } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { getNotificationPermission, notificationChannelTypes, notificationListPageSize, notificationStatusHeaders } from "./notificationConstant";
import Alert from "../layout/Alert";
import { selectMenuProps } from "../../utils/selectMenuProps";
import PhoneInput from "react-phone-input-2";
import { format } from "date-fns";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';




const notificationAnalyticsSx = {
  "& .displayEnd": { display: "flex", justifyContent: "flex-end" },
  "& .search-user": {
    "& .MuiInput-underline:before": { display: 'none' },
    "& .MuiInput-underline:after": { display: 'none' },
    "& .MuiAutocomplete-root": {
      "& .MuiFormControl-root": {
        borderTop: "#ccc solid 1px !important",
        borderBottom: "#ccc solid 1px !important",
      },
      "& .MuiInputBase-input": {
        padding: "0px",
        height: "38px",
        width: "152px !important",
        marginLeft: "8px"
      },
      "& .MuiInputBase-input:focus": {
        borderBottom: "none"
      }
    },
  },
};

const severityOptions = [
    { label: "None", value: null },
    { label: "Info", value: "info" },
    { label: "Alert", value: 'alert' },
    { label: 'Recommendation', value: "recommendation" },
    { label: "Promotion", value: "promotion" }]

const FindNotification = ({ notificationData = {},
    getNotificationTask = () => { },
    searchNotificationsByUserId = () => { },
    searchNotifications = () => { },
    allowedCountries,
    userData,
    tenantData,
    setDialog,
    setDialogContents,
    setDialogTab,
    userRoles = []
    //setCustomAlert
}) => {

    let searchOptions = []
    if (getNotificationPermission(userRoles, 'getNotificationList')) {
        searchOptions = [
            { label: "User ID", value: "userId", placeholder: "Enter User ID" },
            { label: "User E-mail ID", value: 'email', placeholder: "Enter User Email ID" },
            { label: 'User Mobile no', value: "mobile", placeholder: "Enter Mobile no without code" }
        ]
    }
    if (getNotificationPermission(userRoles, 'getNotificationTask')) {
        searchOptions = [...searchOptions,
        { label: "Task ID", value: "taskId", placeholder: "Enter Task ID" }
        ]
    }

    // add key value pair for any new column to be added to the table. 
    // Key should be same as the key in the response and value should be what you want the header for the column to be
    const notificationHeaders =
    {
        uniqueId: { label: "Unique Id" },
        // notificationType: { label: "Type" },
        sentAt: { label: "Created At" },
        severity: { label: "Severity" },
        action: { label: "Actions", style: { display: 'flex', justifyContent: "flex-end" } }
    }

    const [notificationList, setNotificationList] = useState([]);
    const [updateFlag, setUpdateFlag] = useState(Math.random());
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [paginationStartIndex, setPaginationStartIndex] = useState(0);
    const [lastApiPageFetched, setLastApiPageFetched] = useState(0);
    const [pageEndReached, setPageEndReached] = useState(false);
    const [taskId, setTaskId] = useState({ value: "", textValue: "" });
    const [showNotificationList, setShowNotificationList] = useState(false);
    const [searchBy, setSearchBy] = useState(searchOptions[0]?.value)
    const [countryCode, setCountryCode] = useState("91");
    const [searchStr, setSearchStr] = useState("");
    const [tableHeaders, setTableHeaders] = useState({});
    const [pageIndex, setPageIndex] = useState(1);
    const [severityFilter, setSeverityFilter] = useState(null);

    const pageSize = 20;
    const totalPageCount = Math.ceil(notificationList?.length / pageSize);
    const startIndex = pageSize * currentPage;
    const endIndex = startIndex + pageSize;

    const searchNotificationData = (pg, severity = null) => {
        switch (searchBy) {
            case "userId":
                searchNotificationsByUserId(searchStr, pg, severity)
                break;
            case "mobile":
            case "email":
                searchNotificationsByUserId(userData?.user?.userId, pg, severity)
                break;
        }
    }

    const getNextPage = () => {
        const newPg = pageIndex + 1
        setPageIndex(newPg);
        searchNotificationData(newPg, severityFilter);
    }

    const getPrevPage = () => {
        const newPg = pageIndex - 1;
        setPageIndex(newPg);
        searchNotificationData(newPg, severityFilter);
    }

    const pageNumbersToShow = () => {
        if (totalPageCount === 0) {
            return [0];
        } else {
            let i = paginationStartIndex;
            let pagesToShow = [];
            while (i < totalPageCount && i < paginationStartIndex + 5) {
                pagesToShow.push(i);
                i += 1;
            }
            return pagesToShow;
        }
    };

    const onSubmit = (e) => {
        e?.preventDefault();
        setShowNotificationList(true);
        setPageIndex(1);

        switch (searchBy) {
            case "userId":
                searchNotificationsByUserId(searchStr)
                break;
            case "taskId":
                getNotificationTask(taskId?.textValue);
                break;
            case "mobile":
                searchNotifications(searchBy, `+${countryCode}${searchStr}`, 1, tenantData?.tenantId)
                break;
            case "email":
                searchNotifications(searchBy, searchStr, 1, tenantData?.tenantId)
                break;
        }
    }
    useEffect(() => {
        if (showNotificationList) {
            if (notificationData?.lastAction?.includes("get_notification_task") && taskId?.textValue !== "" && notificationData?.lastAction?.includes(taskId?.textValue)) {
                // dont remove second and third condititon-check after setTimeout call from previous page is executed and get empty data after data is populated in table
                setNotificationList(JSON.stringify(notificationData?.notificationDetails) !== "{}" ? [{
                    fullTaskId: notificationData?.notificationDetails?.taskId,
                    taskId: <div title={notificationData?.notificationDetails?.taskId}>
                        {
                            "..." + notificationData?.notificationDetails?.taskId?.slice(notificationData?.notificationDetails?.taskId?.length - 6, notificationData?.notificationDetails?.taskId?.length)
                        }
                    </div>,
                    userCount: <div title="The expected number of users that will receive the  notification.">
                        {
                            notificationData?.notificationDetails?.status?.notificationProcessStatus?.userSentCount
                        }
                    </div>,
                    expectedUserCount: <div title={"The number of users that received the notification."}>
                        {
                            notificationData?.notificationDetails?.status?.taskProcessStatus?.userCount + notificationData?.notificationDetails?.status?.taskProcessStatus?.userFailedCount
                        }
                    </div>,
                    taskStatus: notificationData?.notificationDetails?.status?.taskStatus,
                    failureCount: <div title="The number of users the notification failed to reach.">
                        {notificationData?.notificationDetails?.status?.notificationProcessStatus?.failedUserSentCount + notificationData?.notificationDetails?.status?.notificationProcessStatus?.tokenNotFoundUserCount + notificationData?.notificationDetails?.status?.taskProcessStatus?.userFailedCount
                        }
                    </div>,
                    notificationType: notificationChannelTypes[notificationData?.notificationDetails?.channel?.type + "Notification"]?.label,
                    severity: notificationData?.notificationDetails?.severity,
                    createdAt: format(new Date(notificationData?.notificationDetails?.creationDate * 1000), "dd MMM yyyy 'AT' hh:mm a"),
                    expiryDate: format(new Date(notificationData?.notificationDetails?.expiry * 1000), "dd MMM yyyy 'AT' hh:mm a"),
                    payload: { ...notificationData?.notificationDetails },
                    msg: notificationData?.notificationDetails?.message?.payload,
                    copied:false,
                    action: (data) => {
                        return <button
                            className="btn btn-style-2 orange-bg"
                            onClick={e => {
                                setDialogContents({ title: "Notification Details", content: "notificationDetails", data })
                                setDialog(true);
                                setDialogTab(0);
                            }}
                        >
                            View
                        </button>
                    }

                }] : [])
            }
            else if (notificationData?.lastAction?.includes("search_notification")) {
                setNotificationList(notificationData?.notificationDetails?.map(n => {
                    return {
                        sentAt: format(new Date(n?.ts * 1000), "dd MMM yyyy 'AT' hh:mm a"),
                        severity: n?.severity,
                        payload: { ...n },
                        fullUniqueId: n?.uniqueId,
                        uniqueId: <div title={n?.uniqueId}>
                            {
                                "..." + n?.uniqueId?.substring(n?.uniqueId?.length - 6, n?.uniqueId?.length)
                            }
                        </div>,
                        msg: n?.message?.payload,
                        copied:false,
                        action: (data) => {
                            return <button
                                className="btn btn-style-2 orange-bg"
                                onClick={e => {
                                    setDialogContents({ title: "Notification Details", content: "userNotificationDetails", data })
                                    setDialog(true);
                                    setDialogTab(0);
                                }}
                            >
                                View
                            </button>
                        }

                    }
                }))
            }
            setTableHeaders(searchBy === "taskId" ? notificationStatusHeaders : notificationHeaders)
        }
    }, [notificationData?.lastAction])



    const reset = () => {
        setUpdateFlag(Math.random());
    };

    const filter = () => {

        setCurrentPage(0);
        setPaginationStartIndex(0);
        setPageEndReached(false);
        setLastApiPageFetched(0);
        setUpdateFlag(Math.random());
        setShowNotificationList(true);
    };

    if (isLoading) {
        return (
            <div
                style={{
                    display: "grid",
                    placeItems: "center",
                    height: "80vh",
                }}
            >
                <CircularProgress size="5em" style={{ color: "#AFB42B" }} />
            </div>
        );
    }

    return (
        <Fragment>
            <Box sx={{ ...notificationAnalyticsSx, width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <div className="content-block bottom-shadow mb-0 search-filter-block search-notification-filter" style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box" }}>
                            <div className="p-15">
                                <div className="search-filter-filter">
                                    <div className="search-filter-title">
                                        <span className="black-text font-600">Search Notification</span>
                                    </div>
                                    <div className="search-filter-controls">
                                        <span className="search-filter-search-by">Search By</span>
                                        <FormControl variant="outlined" size="medium" className="search-filter-type-select">
                                            <Select
                                                name="searchBy"
                                                value={searchBy}
                                                onChange={(e) => {
                                                    setSearchStr("");
                                                    setShowNotificationList(false);
                                                    setSearchBy(e?.target?.value);
                                                }}
                                                MenuProps={selectMenuProps}
                                            >
                                                {searchOptions?.map((o, i) => (
                                                    <MenuItem key={o?.value} value={o?.value}>{o?.label}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <div className="search-notification-input-btn-unit">
                                        <div className="search-filter-input-wrap">
                                            <div
                                                className={
                                                    searchBy === "mobile"
                                                        ? "search-device not-found right no-left-pad"
                                                        : "search-device not-found right"
                                                }
                                            >
                                                {searchBy === "mobile" ? (
                                                    <PhoneInput
                                                        enableSearch={false}
                                                        value={countryCode}
                                                        onChange={setCountryCode}
                                                        containerClass="country-code-container"
                                                        searchClass="country-code-search"
                                                        dropdownClass="country-code-dropdown"
                                                        onlyCountries={allowedCountries}
                                                    />
                                                ) : (
                                                    <i className="material-icons search-icon"> search</i>
                                                )}
                                                {searchBy !== "taskId" ? (
                                                    <input
                                                        className="add-input search-notification-input-height"
                                                        required
                                                        placeholder={searchOptions?.find(o => o?.value === searchBy)?.placeholder}
                                                        type={searchBy === "mobile" ? "number" : "text"}
                                                        name="text"
                                                        value={searchStr}
                                                        onChange={(e) => {
                                                            setSearchStr(e?.target?.value)
                                                            setShowNotificationList(false)
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                e.preventDefault();
                                                                onSubmit(e);
                                                            }
                                                        }}
                                                    />
                                                ) : (
                                                    <Autocomplete
                                                        freeSolo
                                                        fullWidth
                                                        id="asynchronous-demo"
                                                        value={taskId?.value}
                                                        inputValue={taskId?.textValue || ""}
                                                        onInputChange={(e, value) => {
                                                            value = value ?? ""
                                                            setTaskId({ ...taskId, textValue: value })
                                                            setShowNotificationList(false)
                                                        }}
                                                        onChange={(e, value) => {
                                                            setTaskId({ value, textValue: value })
                                                            setShowNotificationList(false)
                                                        }}
                                                        options={notificationData?.taskList || []}
                                                        getOptionLabel={(option) => option != null ? String(option) : ''}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Enter Task ID"
                                                                variant="outlined"
                                                                size="small"
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    notched: false,
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className="search-filter-btn">
                                            <input
                                                type="button"
                                                value="Search"
                                                className="btn orange-bg btn-block search-notification-btn-height no-shadow"
                                                onClick={(e) => onSubmit(e)}
                                            />
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
                <Alert />
                {
                    showNotificationList &&
                    <Box className="content-block bottom-shadow py-15 mb-30" sx={{ width: "100%", minWidth: 0, overflow: "hidden" }}>
                        {
                            <Box className="displayEnd" sx={{ marginBottom: 2, padding: 2, flexWrap: "wrap" }}>
                                {
                                    searchBy === "taskId" ?
                                        getNotificationPermission(userRoles, "cancelNotification") && showNotificationList &&
                                        <button
                                            disabled={notificationList[0]?.taskStatus === "cancelled" || !notificationList[0]?.hasOwnProperty("taskId")}
                                            className="btn btn-style-2 orange-bg"
                                            onClick={(e) => {
                                                setDialogContents({ title: "Cancel Notification", content: "cancelNotification", data: notificationList[0] })
                                                setDialog(true);
                                            }}
                                        >
                                            Cancel Notification
                                        </button>
                                        :
                                        showNotificationList &&
                                        <div className="model-srch reset FilterBox">
                                            <label className="field-name active">
                                                Filter By Severity
                                            </label>
                                            <FormControl variant="outlined" size="small" className="custom-select select-reset">
                                                <Select
                                                    name="filter"
                                                    value={severityFilter ?? ""}
                                                    onChange={(e) => {
                                                        const v = e?.target?.value === "" || e?.target?.value === "None" ? null : e?.target?.value;
                                                        setSeverityFilter(v);
                                                        setPageIndex(1);
                                                        searchNotificationData(1, v);
                                                    }}
                                                    displayEmpty
                                                    renderValue={(v) => (v == null || v === "" ? "None" : severityOptions?.find(o => o?.value === v)?.label || v)}
                                                    MenuProps={selectMenuProps}
                                                >
                                                    {severityOptions?.map((o, i) => (
                                                        <MenuItem key={o?.value ?? i} value={o?.value ?? ""}>{o?.label}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                }
                            </Box>
                        }
                        <Box sx={{ width: "100%", minWidth: 0 }}>
                            <Box
                                className="table-wrapper mb-20"
                                sx={{
                                    overflowX: "auto",
                                    overflowY: "auto",
                                    maxHeight: "58vh",
                                }}
                            >
                                    <table
                                        width="100%"
                                        align="center"
                                        className="table style-4 mb-20 notificationDataTable"
                                    >
                                        <thead
                                            style={{ position: "sticky", top: 0, zIndex: 50, background: "white" }}
                                        >
                                            <tr>
                                                {Object.keys(tableHeaders).map((key, ind) => (
                                                    <th style={tableHeaders[key]?.hasOwnProperty("style") ? tableHeaders[key]?.style : {}} key={ind}>{tableHeaders[key]?.label}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {notificationList.length === 0 ? (
                                                <tr>
                                                    <td colSpan={Object.keys(tableHeaders).length}>
                                                        No Data found
                                                    </td>
                                                </tr>
                                            ) : (
                                                notificationList
                                                    .slice(startIndex, endIndex)
                                                    .map((element, index) => {
                                                        return (
                                                            <tr key={index % pageSize} id={index % pageSize}>
                                                                {Object.keys(tableHeaders).map((key, ind) => {
                                                                    return (
                                                                        <td key={ind}
                                                                            style={tableHeaders[key]?.hasOwnProperty("style") ? tableHeaders[key]?.style : {}}
                                                                            className={
                                                                                String(element[key]).length > 200
                                                                                    ? "breakWord"
                                                                                    : ""
                                                                            }
                                                                        >
                                                                            <div style={{ display: 'flex', alignItems: "center" }}>
                                                                                {element?.hasOwnProperty(key) ? typeof element[key] === 'function' ? element[key](element) : element[key] : "-"}
                                                                                {(key === "taskId" || key === "uniqueId") &&
                                                                                    <div onClick={e => {
                                                                                        setNotificationList(notificationList?.map((n,i)=>{
                                                                                            if(i===index){
                                                                                                n.copied=true
                                                                                            }
                                                                                            return n;
                                                                                        }))
                                                                                        setTimeout(() => {
                                                                                            setNotificationList(notificationList?.map((n,i)=>{
                                                                                                if(i===index){
                                                                                                    n.copied=false
                                                                                                }
                                                                                                return n;
                                                                                            }))
                                                                                        }, 3000)
                                                                                        navigator?.clipboard?.writeText(element?.fullTaskId || element?.fullUniqueId)
                                                                                    }} title="Copy" style={{ marginLeft: "8px" }}>
                                                                                        {
                                                                                            element?.copied ?
                                                                                            <CheckCircleOutlineIcon />
                                                                                            :
                                                                                            <FileCopyIcon />
                                                                                        }
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </td>
                                                                    );
                                                                })}
                                                            </tr>
                                                        );
                                                    })
                                            )}
                                        </tbody>
                                    </table>
                            </Box>
                                {
                                    searchBy !== "taskId" &&
                                    <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mt: 1 }}>
                                        <button
                                            className="btn btn-style-2 orange-bg"
                                            style={{ marginRight: "12px" }}
                                            onClick={e => getPrevPage()}
                                            disabled={pageIndex === 1}
                                        >
                                            Previous
                                        </button>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            {`Page : ${pageIndex}`}
                                            <button
                                                style={{ marginLeft: "8px" }}
                                                className="btn btn-style-2 orange-bg"
                                                onClick={e => getNextPage()}
                                                disabled={notificationList?.length < notificationListPageSize}
                                            >
                                                Next
                                            </button>
                                        </div>
                                    </Box>}
                            </Box>
                        </Box>
                }
            </Box>
        </Fragment >
    );
};

export default FindNotification;
